/**
 * **Geänderte Aufgaben in den Bestand einflicken** (17.09.2026,
 * [E-363](../../../../docs/ENTSCHEIDUNGEN.md#e-363)).
 *
 * Nach einer Live-Nachricht holt der Client nur noch die genannten Aufgaben (`tasks.all` mit
 * `ids`) statt des ganzen Bestands. Diese Funktion setzt sie ein:
 *
 * | angefragt | zurückgekommen | Wirkung |
 * |---|---|---|
 * | ja | ja | Zeile ersetzt oder neu aufgenommen |
 * | ja | nein | Zeile entfernt – gelöscht, verschmolzen oder nicht mehr sichtbar |
 * | nein | – | unverändert |
 *
 * Die Reihenfolge ist die des Servers (`updated_at` absteigend), damit eine geflickte Liste
 * aussieht wie eine frisch geladene.
 */
export function bestandFlicken<T extends { id: string; updatedAt: string | Date }>(
  alt: readonly T[],
  angefragt: readonly string[],
  neu: readonly T[],
): T[] {
  const weg = new Set(angefragt)
  const ergebnis = alt.filter((a) => !weg.has(a.id))
  ergebnis.push(...neu.filter((n) => weg.has(n.id)))
  const zeit = (a: T) => new Date(a.updatedAt).getTime()
  return ergebnis.sort((a, b) => zeit(b) - zeit(a))
}

/** Ab so vielen gesammelten Kennungen lohnt das Flicken nicht – dann der ganze Bestand. */
export const FLICKEN_HOECHSTENS = 200
